import { BundleBottleImage } from "./bundle-bottle-image";


const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      background-color: #1d3143;
      
      position: relative;
      height: auto;
      padding-bottom: 40%; 
      margin: 0.625rem;
    }

    img {
      position: relative;
      width: 88vw;
      height: auto;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      z-index: 1;
    }

    .bundle-image__wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: gap 0.3s ease-in-out;
      gap: 1.4vw;
    }

    @media screen and (min-width: 767px) {
      img {
        width: 64vw;
      }

      :host {
        padding-bottom: 34%;
      }

      .bundle-image__wrapper {
        gap: 0.5vw;
      }
    }

    @media screen and (min-width: 991px) {
      img {
        width: 51vw;
      }
    }

  </style>
  <div class="bundle-image" part="image">
    <div class="bundle-image__wrapper">
      <img src="https://cdn.shopify.com/s/files/1/0492/9857/1425/files/box_front_with_shadow-cut.png?v=1696567093">
      <slot></slot>
    </div>
  </div>
`;

export class BundleImage extends HTMLElement {

  private readonly root:HTMLDivElement;
  private bottleImages:BundleBottleImage[];

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));


    this.root = shadowRoot.querySelector('.bundle-image')!;
    const img = shadowRoot.querySelector("img");
    const giftBoxImg = this.getAttribute("gift-box-image");
    
    window.addEventListener('resize', () => {
      this.setImageWidthToHost(img);
    });

    if (img && giftBoxImg) {
      img.src = giftBoxImg;
    }

    const slotElement = shadowRoot.querySelector('slot');

    this.bottleImages = slotElement?.assignedElements() as BundleBottleImage[];

  }

  connectedCallback() {
    const img = this.shadowRoot!.querySelector("img");
    this.setImageWidthToHost(img);
  }

  private setImageWidthToHost(img) {
    const width = img.offsetWidth;
    this.style.width = `${width}px`;
  }

  public resetImage() {

    this.bottleImages.forEach((bottle_image, i) => {
      this.setBottleImage(i, null);
    });

    this.setStep(0);
  }

  public setHasGlass(hasGlass:boolean) {
    this.bottleImages.forEach(bottle => {
      bottle.setHasGlass(hasGlass);
    });
  }

  public setStep(stepIndex:number) {
    this.bottleImages.forEach((bottleImage, index) => {
      if (typeof bottleImage.setActive === 'function') {
        bottleImage.setActive(stepIndex === index);
      }
    })
  }

  public setBottleImage(stepIndex:number, imageSrc:string|null) {
    this.bottleImages[stepIndex].setImageSrc(imageSrc);
  }
}

if(!customElements.get('bundle-image')) {
  customElements.define('bundle-image', BundleImage);
}